import "./App.css";
import { useMediaQuery } from 'react-responsive';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Faq from "./pages/Faq";
import About from "./pages/About";
import Services from "./pages/Services";
import Testimonials from "./pages/Testimonials";
import Contact from "./pages/Contact";
import Booking from "./pages/Booking";
import Resources from "./pages/Resources";
import Terms from "./pages/Terms";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import LargeScreenNavBar from "./components/LargeScreenNavBar";

function App() {
  //const isSmallScreen = useMediaQuery({ query: "(min-device-width: 480px)" });
  const isLargeScreen = useMediaQuery({ query: "(min-device-width: 1024px)" });
 
  return (
    <Router>
      {isLargeScreen ? (
        <LargeScreenNavBar></LargeScreenNavBar>
      ) : (
        <NavBar></NavBar>
      )}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
      <Footer></Footer>
    </Router>
  )
};

export default App;